import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { JsReadService } from 'src/app/services/apis/java/spring/js-read/js-read.service';

@Injectable({
  providedIn: 'root'
})
export class TgUserIpService {

  constructor(
    public jsRead: JsReadService,
  ) { }

  // JS: Java - Spring - get/all
  jsGetAll(): Observable<any> {
    return this.jsRead.getAll(
      'tg/user/ip'
    );
  }

  // JS: Java - Spring - page/all
  jsGetPage(): Observable<any> {
    return this.jsRead.getPage(
      'tg/user/ip'
    );
  }
}
